<template lang="pug">
  div
    .d-flex.align-items-center.justify-content-between.mb-2
      b-link.text-sm(:to="{name: 'logout'}") Cerrar sesión
      b-dropdown(size="sm", variant="link", right, no-caret, v-if="languages.length > 1")
        template(slot="button-content")
          .d-flex.align-items-center
            v-icon(name="language", scale="1.5", :class="selectedLanguage != 1 ? 'text-primary' : 'text-secondary'")
            chevron-down-icon.icon-sm.ml-1(:class="selectedLanguage != 1 ? 'text-primary' : 'text-secondary'")
          //- span.ml-1.text-sm.text-help(v-if="selectedLanguage != 1 && selectedLocale && $breakpoint.mdUp") ({{ selectedLocale }})
        b-dropdown-item(v-for="language in languages", :key="language.language_id", :active="selectedLanguage == language.language_id", @click="changeLanguage(language.language_id)") {{ language.name }}
      //b-button.border-0(variant="outline-primary", size="sm", @click="requestPushPermissions", v-if="!pushEnabled", v-b-tooltip="'Activar notificaciones'")
        bell-icon.icon-md
      bell-icon.icon-md.text-success(v-b-tooltip="'Notificaciones activadas'", v-else)
    b-dropdown.mb-2(variant="light", no-caret, class="btn-block", :menu-class="['fit-width', 'text-truncate', 'scroll-dropdown', 'scrollable-area', 'overflow-y']", v-if="admin_accounts.length > 1")
      template(slot="button-content")
        .d-flex.align-items-center.justify-content-between.position-relative
          //b-img.santa-hat(src="@/assets/santa.png", width="45")
          //b-img.crown(src="@/assets/crown.png", width="40")
          .text-left(style="flex: 1;")
            h4.mb-0.break-space {{ account.name }}
            p.mb-0.text-sm.text-truncate.text-secondary.break-space de {{ organization.name }}
          chevron-down-icon
      b-dropdown-header Cambiar de cuenta
      b-dropdown-item(v-for="account in admin_accounts", :key="account.account_id", :link-class="['break-space']", @click="changeAccount(account.account_id)")
        .break-space {{ account.name }}
    .mb-2(v-else)
      .d-flex.align-items-center.justify-content-between
        h4.mb-0 {{ account.name }}
        //settings-icon.icon-md.pointer.hover-primary.text-secondary(v-b-tooltip.hover="'Ajustes de cuenta'", @click="account_settings_modal = true")
      span.text-sm.text-secondary.text-truncate de {{ organization.name }}
    span.text-help.text-sm.text-truncate
      span.text-success.mr-1 ●
      span {{ getCurrentUser().email }}
    b-modal(v-model="account_settings_modal", size="lg", :title="'Configuración de ' + account_name", ok-title="Guardar", cancel-title="Cancelar", ok-variant="primary", @ok="updateAccount")
      b-row
        b-col.d-flex.flex-column.align-items-center.justify-content-start.mb-3(cols="12", md="auto")
          label.text-secondary Imagen de cuenta
          Avatar.pointer.mb-2(size="xl", :src="account.image", @click="$refs.input_image.click()", v-b-tooltip.hover, :title="account.image ? 'Cambiar imagen' : 'Subir imagen'")
          b-link.text-danger.text-sm.mb-4(v-if="account.image", @click="$store.commit('account/updateAccountAttribute', {attribute: 'image', value: ''})") Quitar imagen
          b-link.text-primary.text-sm.mb-4(v-else, @click="$refs.input_image.click()") Subir imagen
          label.text-secondary Imagen de chatbot
          Avatar.pointer.mb-2(size="lg", :src="account.bot_image", @click="$refs.input_bot_image.click()", v-b-tooltip.hover, :title="account.bot_image ? 'Cambiar imagen' : 'Subir imagen'")
          b-link.text-danger.text-sm(v-if="account.bot_image", @click="$store.commit('account/updateAccountAttribute', {attribute: 'bot_image', value: ''})") Quitar imagen
          b-link.text-primary.text-sm(v-else, @click="$refs.input_bot_image.click()") Subir imagen
        b-col
          b-card
            h6 Información del representante de la cuenta
            b-form.mt-3
              b-form-group
                label.text-secondary Nombre del representante
                b-form-input(v-model.trim="account.representative_name", placeholder="Nombre", :state="account.representative_name ? null : (validated ? false : null)")
              b-form-group
                label.text-secondary Email
                b-form-input(v-model.trim="account.email", placeholder="Email", :state="account.email ? null : (validated ? false : null)")
              b-form-group
                label.text-secondary Teléfono
                b-form-input(v-model.trim="account.phone", placeholder="Teléfono", :state="account.phone ? null : (validated ? false : null)")
              b-form-group
                label.text-secondary Giro del negocio
                b-form-input(v-model.trim="account.business_turn", placeholder="Giro", :state="account.business_turn ? null : (validated ? false : null)")
    input(type="file", accept="image/*", style="display:none;", ref="input_image", @change="imageSelected($event, 'image')")
    input(type="file", accept="image/*", style="display:none;", ref="input_bot_image", @change="imageSelected($event, 'bot_image')")
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import Avatar from '@/components/Avatar.vue'
import { getItem } from '@/helpers/storage-manager'
import { UploadFile } from "@/helpers/upload-file";
const accountController = createNamespacedHelpers('account')
const organizationController = createNamespacedHelpers('organization')
const adminController = createNamespacedHelpers('admin')

export default {
  data () {
    return {
      account_settings_modal: false,
      file_image: null,
      file_bot_image: null,
      validated: false,
      pushEnabled: false
    }
  },
  computed: {
    ...accountController.mapState({
      account: state => state.account,
      languages: state => state.languages
    }),
    ...organizationController.mapState({
      organization: state => state.organization
    }),
    ...accountController.mapGetters(['selectedLanguage', 'selectedLocale']),
    account_name () {
      return this.account.name || 'la cuenta'
    },
    ...adminController.mapState({
      admin: state => state.admin
    }),
    admin_accounts () {
      if(!this.admin || !this.admin.Accounts) return []

      return this.admin.Accounts.filter(a => a.account_id != this.account.account_id).map(a => {
        return {
          account_id: a.account_id,
          name: a.name
        }
      })
    }
  },
  methods: {
    ...mapActions(['account/update', 'helpers/upload_file', 'admin/get']),
    ...accountController.mapMutations(['changeLanguage']),
    getAdminInfo () {
      let self = this
      this['admin/get']({
        admin_id: self.getCurrentUser().admin_id,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          }
        }
      })
    },
    async updateAccount (modal) {
      modal.preventDefault()
      let self = this

      if(!this.account.representative_name || !this.account.email || !this.account.phone || !this.account.business_turn) {
        this.validated = true
        return
      }

      if (this.file_image) {
        try {
          let new_image = await UploadFile.call(this, this.file_image)
          this.$store.commit('account/updateAccountAttribute', {attribute: 'image', value: new_image})
          this.file_image = null
        } catch (e) {
          this.$message.error(e.message)
        }
      }

      if (this.file_bot_image) {
        try {
          let new_bot_image = await UploadFile.call(this, this.file_bot_image)
          this.$store.commit('account/updateAccountAttribute', {attribute: 'bot_image', value: new_bot_image})
          this.file_bot_image = null
        } catch (e) {
          this.$message.error(e.message)
        }
      }

      this['account/update']({
        ...self.account,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Cuenta actualizada.')
            self.account_settings_modal = false
          }
        }
      })
    },
    imageSelected(event, key) {
      let files = event.target.files

      if(files.length) {
        let file = files[0]
        try {
          this.$store.commit('account/updateAccountAttribute', {attribute: key, value: URL.createObjectURL(file)})
          this['file_' + key] = file
        } catch (e) {
          this.$message.warning('No logramos crear la vista previa de la imagen, por favor comprueba tu conexión a internet')
        }
      }
      this.$refs['input_' + key].value = ''
    },
    changeAccount (account_id) {
      this.$router.push({ params: {account_id: account_id} }).catch(()=>{});
      window.location.reload()
    },
    async checkPushStatus (isAfterRequest = false) {
      const OneSignal = window.OneSignal || false
      if(!OneSignal) return
      this.pushEnabled = await OneSignal.isPushNotificationsEnabled()

      if (this.pushEnabled && isAfterRequest) {
        this.$message.success('Notificaciones activadas.')
      }
    },
    async requestPushPermissions () {
      const OneSignal = window.OneSignal || false
      if(!OneSignal) return
      OneSignal.showSlidedownPrompt({ force: true }).then(res => {
        console.log(res)
        this.checkPushStatus(true)
      });
    }
  },
  created () {
    if (getItem('selectedLanguage')) {
      this.$store.commit('account/changeLanguage', getItem('selectedLanguage'))
    }
  },
  mounted() {
    this.getAdminInfo()
    //this.checkPushStatus()
  },
  components: {Avatar}
}
</script>

<style lang="scss">
.fit-width {
  max-width: 240px;
  overflow-x: auto;
}
.break-space {
  white-space: break-spaces;
  word-break: break-word;
}

.santa-hat {
  top: -20px;
  left: -22%;
  position: absolute;
}
.crown {
  top: -24px;
  left: -20%;
  position: absolute;
  transform: rotate(-40deg);
}
</style>
